class GatedContent {
	constructor(blockEl) {
		this.gatedContent = blockEl.querySelector('#gated-content');
		this.underlyingContent = blockEl.querySelector('#underlying-content');

		if (this.gatedContent) {
			this.init();
		}
	}

	init() {
		this.underlyingContent.style.visibility = 'hidden';
		this.underlyingContent.style.display = 'none';
		const form = this.gatedContent.querySelector('form');
		if (form) {
			const observer = new MutationObserver((mutations, obs) => {

				const confirmationMessage = mutations.flatMap((mutationRecord) => {
					if (mutationRecord.type === 'childList') {
						return Array.from(mutationRecord.addedNodes);
					}
				}).find(node => node.classList?.contains('gform_confirmation_wrapper'));


				if (confirmationMessage) {
					this.cleanPopUpForm();
					obs.disconnect();
				}
			});

			observer.observe(this.gatedContent, {
				childList: true,           // watch for addition/removal of child nodes
				subtree: true,           // watch all levels down from `form`
				characterData: true
			});

		}
	}

	cleanPopUpForm() {
		this.gatedContent.style.display = 'none';
		this.underlyingContent.style.visibility = 'visible';
		this.underlyingContent.style.display = 'flex';
	}
}

export default GatedContent;
